import { render, staticRenderFns } from "./ispDashboard.vue?vue&type=template&id=443d504f&"
import script from "./ispDashboard.vue?vue&type=script&lang=js&"
export * from "./ispDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports